class ContentVideoBlock extends HTMLElement {
  constructor() {
    super();

    if (this.getAttribute('aria-controls')) {
      const controls = this.getAttribute('aria-controls')
        .split(' ')
        .map((id) => document.getElementById(id));

      controls.forEach((control) => {
        if (!control) {
          return;
        }
        control.addEventListener('swatch:change', (e) => this.fetchVideoText(e.detail.swatch));
      });
    }

    this.video = this.querySelector('video') || false;
    this.button = this.querySelector('button') || false;

    this.init();
  }

  init() {
    if (this.video && this.button) {
      this.button.addEventListener('click', this.toggleSound.bind(this));
    }
  }

  toggleSound() {
    if (this.video.muted) {
      this.video.muted = false;
      this.button.classList.remove('muted');

      return;
    }

    this.video.muted = true;
    this.button.classList.add('muted');
  }

  async fetchVideoText(swatch) {
    try {
      const response = await fetch(`${swatch.href}?section_id=${this.id}`);
      const result = await response.text();
      this.renderContents(result);
    } catch (e) {
      console.error(`Failed to fetch video/text: ${e.message}`);
    }
  }

  renderContents(parsedState) {
    document.getElementById(this.id).innerHTML = this.getSectionInnerHTML(parsedState, `#${this.id}`);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define('content-video-block', ContentVideoBlock);
